function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "list_alt_24px"
}, /*#__PURE__*/React.createElement("path", {
  id: "icon/communication/list_alt_24px",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.75 2.5H3.25C2.83333 2.5 2.5 2.83333 2.5 3.25V16.75C2.5 17.0833 2.83333 17.5 3.25 17.5H16.75C17.0833 17.5 17.5 17.0833 17.5 16.75V3.25C17.5 2.83333 17.0833 2.5 16.75 2.5ZM7.50009 5.83336H5.83343V7.50002H7.50009V5.83336ZM14.1666 5.83336H9.16657V7.50002H14.1666V5.83336ZM14.1666 9.16664H9.16657V10.8333H14.1666V9.16664ZM9.16657 12.5H14.1666V14.1667H9.16657V12.5ZM5.83343 9.16664H7.50009V10.8333H5.83343V9.16664ZM7.50009 12.5H5.83343V14.1667H7.50009V12.5ZM4.16657 15.8333H15.8332V4.16664H4.16657V15.8333Z"
}));

var SvgListAlt = function SvgListAlt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgListAlt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/list_alt.c9e66165.svg";
export { ForwardRef as ReactComponent };